import { VictoryPointStateReader } from '@colonist/game-base-types';
import { useGameStore } from '../../store/GameStoreContext.ts';
export const usePlayerVictoryPoints = (playerColor)=>{
    const publicVictoryPoints = useGameStore((state)=>{
        const playerState = state.gameState.playerStates[playerColor];
        if (playerState === undefined) return 0;
        return VictoryPointStateReader.totalPublicVictoryPoints(playerState.victoryPointsState);
    });
    const privateVictoryPoints = useGameStore((state)=>{
        const playerState = state.gameState.playerStates[playerColor];
        if (playerState === undefined) return 0;
        return VictoryPointStateReader.totalPrivateVictoryPoints(playerState.victoryPointsState);
    });
    return {
        publicVictoryPoints: publicVictoryPoints,
        privateVictoryPoints: privateVictoryPoints
    };
};
